import { Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';
import { SnSearchItem } from './search-item';

export class SnSearchResponse extends SnModel {
  @Expose()
  @Type(() => SnSearchItem)
  public fusus: SnSearchItem[];

  @Expose()
  @Type(() => SnSearchItem)
  public googlePlaces: SnSearchItem[];

  @Expose()
  @Type(() => SnSearchItem)
  public googleAddresses: SnSearchItem[];

  @Expose()
  @Type(() => SnSearchItem)
  public avlResults: SnSearchItem[];

  @Expose()
  @Type(() => SnSearchItem)
  public cadResults: SnSearchItem[];

  @Expose()
  @Type(() => SnSearchItem)
  public assets: SnSearchItem[];

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
